module.exports = __webpack_public_path__ + "img/6.63cf5eb6.svg";